import usePersistUser from '@/hooks/usePersistUser'
import PageNotFound from '@/views/404/404'
import { Route, Routes } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'
import routes from './data/routes'

export function Router() {
  const { isAuthenticated, isLoading } = usePersistUser()

  return (
    <Routes>
      <Route path="/">
        <Route
          element={
            <ProtectedRoute
              accessBy="non-authenticated"
              isAuthenticated={isAuthenticated}
            />
          }
        >
          {routes.nonAuthenticated.map((route, index) => (
            <Route element={<route.component />} key={index} path={route.path} />
          ))}
        </Route>
        {/* AUTH */}
        <Route
          element={
            <ProtectedRoute
              accessBy="authenticated"
              isAuthenticated={isAuthenticated}
              loading={isLoading}
            />
          }
        >
          {routes.authenticated.map((route, index) => (
            <Route element={<route.component />} key={index} path={route.path} />
          ))}
        </Route>
      </Route>
      {/* 404 */}
      <Route element={<PageNotFound />} path="*" />
    </Routes>
  )
}
